.main-search-wrap{
    :global{
        .input-group{
            border-bottom: 1px solid #262d40;
            height: 46px;
            border-radius: 0 !important;
            padding: 0 1rem;
            display: flex;
            align-items: center;
            .form-control{
                height: 30px;
                box-shadow: none;
                color: #ffffff !important;
                background: #161E32!important;
                &::placeholder{
                    color: #3B4966;
                }
            }
            .input-group-text{
                height: 30px;
                background: #161E32!important;
                svg{font-size: 12px !important;}
            }
        }
    }
}

.toggle-button-group{
    height: 36px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 1rem;
    overflow: hidden;
    :global{
        .btn{
            padding: 4px .5rem !important;
            font-size: 12px;
            border-radius: 4px !important;
            box-shadow: none !important;
            flex:none;
            margin-right: 4px;
            &:hover{
                color: #fff!important;
                background: none;
            }
        }
        .btn-check:active+.btn, .btn-check:checked+.btn{
            background: #090D1A;
        }
    }
}

.table{
    border-spacing: 0;
    td{padding: 0 8px;}
    thead tr td:first-child{padding-left: 1rem;}
    tbody tr td{cursor: pointer;height: 30px !important;}
}
